import Component from './Login.container';

export default Component;
